import React, { Suspense, useState, useEffect } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
// import AlertModule from "./layouts/AlertModule/index";
import DashBoardLayout from "./layouts/DashBoardLayouts";
import ModulesLayout from "./layouts/CommonLayouts/ModulesLayout";
import Profile from "./layouts/CommonLayouts/Profile";
import { accessibleRoutes, ls } from "./variables";
import Login from "./login/Login";
import SettlementPage from "./layouts/PMSComponents/alertModule/Settlement/SettlementPage";
import TrackerPage from "./layouts/PMSComponents/alertModule/Tracker/TrackerPage";
import SebiUploadUtilityQ from "./layouts/SebiUploadUtility/alertModule/UploadUtility/SebiUploadUtilityQ";
import SebiAlertTracker from "./layouts/SebiUploadUtility/alertModule/Tracker/SebiTracker";
import PMSTakeAction from "./layouts/PMSComponents/alertModule/Settlement/TakeActionTable";
import Settlement from "./layouts/PMSComponents/alertModule/Settlement/SettlementForm";
import PMSTrackerView from "./layouts/PMSComponents/alertModule/Tracker/PMSTrackerView";
import SEBITrackerView from "./layouts/SebiUploadUtility/alertModule/Tracker/SEBITrackerView";
import AnalyticsDashboard from "./quicksight/AnalyticsDashboard";
// import DashBoard from "./layouts/SebiUploadUtility/DashboardLayout/DashBoard";
import GeneralModuleLayout from "./layouts/CommonLayouts/GeneralModuleLayout";
import ErrorPage from "./layouts/DashBoardLayouts/components/ErrorPage";
import ErrorModule from "./layouts/DashBoardLayouts/components/ErrorModule";
import SebiTracker from "./layouts/SebiUploadUtility/CTRModule/index";
import CtrPage from "./layouts/PMSComponents/ctrHytrModule/UploadUtility/LandingPage";
import Tracker from "./layouts/PMSComponents/ctrHytrModule/Tracker/Tracker";
import View from "./layouts/PMSComponents/ctrHytrModule/Tracker/View";
import ActionLayout from "./layouts/CommonLayouts/ActionType";
import ReportGenModule from "./layouts/CommonLayouts/ReportGenModule";
import { checkAuth } from "./utils/checkAuth";
import LoadingSpinner from "./Loader/LoadingSpinner";
import Swal from "sweetalert2";
import axios from "axios";
import { encrypt } from "./utils/cipher";
 
 
const Router = () => {
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(null);
  const [sessionTimeOut, setSessionTimeOut] = useState(0);
  const checkUserType = ls.get("userType");
  const navigate = useNavigate();
  const location = useLocation();
 
  useEffect(() => {
    checkAuth().then(data => {
      setIsUserLoggedIn(data.success);
      setSessionTimeOut(data.expires)
    });
  }, [location.pathname]);
 
  useEffect(() => {
    if (isUserLoggedIn === null) return;
    if (!isUserLoggedIn) {
      navigate("/");
    } else {
      const userAccessibleRoutes = accessibleRoutes[checkUserType] || [];
      const isAccessible = userAccessibleRoutes.some(route => route === location.pathname);
      if (isAccessible) {
        navigate("/app/welcome");
      }
    }
  }, [isUserLoggedIn]);
 
  useEffect(() => {
    if (!isUserLoggedIn) return;
 
    const checkSession = async () => {
      const currentTime = new Date();
      const expiryTime = new Date(sessionTimeOut * 1000);
      const timeDiff = expiryTime - currentTime;
 
      // console.log(Math.round(timeDiff) / 1000)
      if (timeDiff <= 60000 && timeDiff > 0) {
        const result = await Swal.fire({
          title: `Session Expire in 1 minute`,
          text: 'Your session is about to expire. What would you like to do?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: "#154063",
          cancelButtonColor: "#d33",
          confirmButtonText: 'Extend',
          cancelButtonText: 'Logout',
          reverseButtons: true,
          focusConfirm: false,
          focusCancel: false,
          allowOutsideClick: false,
          allowEnterKey: false,
          allowEscapeKey: false,
        });
 
        if (result.isConfirmed) {
          let payload = ls.get("userInfo");
          let encryptedPayload = await encrypt(payload);
          try {
            const res = await axios.post("/api/pms/createToken", { payload: encryptedPayload });
            ls.set("isUserLoggedIn", true);
            ls.set("authToken", res.data.authToken);
            ls.set("refreshToken", res.data.refreshToken);
            setSessionTimeOut(-1);
          } catch (error) {
            console.error(error);
          }
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          try {
            await axios.post("/api/pms/logout", { email: ls.get("email") });
            ls.removeAll();
            setIsUserLoggedIn(false);
            navigate("/");
          } catch (error) {
            console.error(error);
          }
        }
      }
    };
 
    checkSession();
  }, [sessionTimeOut, location.pathname, navigate, isUserLoggedIn]);
 
 
  if (isUserLoggedIn === null) {
    return <LoadingSpinner />;
  }
 
 
  return (
    <Routes>
      {isUserLoggedIn && checkUserType === "PMS" ? (<>
          <Route path="/app" element={<DashBoardLayout />}>
            <Route path="welcome" element={<ModulesLayout />} />
            <Route path="profile" element={<Profile />} />
            <Route path="tracker" element={<TrackerPage />} />
            <Route path="trackerView" element={<PMSTrackerView />} />
            <Route path="upload" element={<SettlementPage />} />
            <Route path="takeAction" element={<PMSTakeAction />} />
            <Route path="takeActionSettlement" element={<Settlement />} />
            <Route path="cmmPage" element={<CtrPage type="cmm" />} />
            <Route path="cmmTracker" element={<Tracker type="cmm" />} />
            <Route path="cmmView" element={<View type="cmm" />} />
            <Route path="cmmLayout" element={<ActionLayout type="cmm" />} />
          <Route path='*' element={<ErrorModule/>} />
          </Route>
        <Route path='*' element={<ErrorPage/>} />
      </>
      ) : isUserLoggedIn && checkUserType === "SEBI" ?
        (<>
          <Route path="/app" element={<DashBoardLayout />}>
            <Route path="profile" element={<Profile />} />
            <Route path="welcome" element={<ModulesLayout />} />
            <Route path="sebiTracker" element={<SebiAlertTracker />} />
            <Route path="sebiCmmTracker" element={<SebiTracker type="cmm" />} />
            <Route path="uploadutilityAlert" element={<SebiUploadUtilityQ />} />
          <Route path='*' element={<ErrorModule/>} />
          </Route>
          {/* <Route path='*' element={<ErrorPage/>} /> */}
        </>
      ) :  isUserLoggedIn && checkUserType === "APMII" ? 
          (<>
            <Route path="/app" element={<DashBoardLayout />}>
              <Route path="profile" element={<Profile />} />
              {/* <Route path="welcome" element={<ModulesLayout />} /> */}
              <Route path="ReportGenModule" element={<ReportGenModule type="quicksight" />} />
              <Route path="Analytics" element={
                <Suspense fallback={<p>Loading page...</p>}>
                  <AnalyticsDashboard id="570502b3-c19a-4781-ba57-1bd01f6c379b" />
                </Suspense>
              } />
              <Route path="Reports" element={
                <Suspense fallback={<p>Loading page...</p>}>
                  <AnalyticsDashboard id="7286270d-8c05-46a1-8611-b6a017dece0b" />
                </Suspense>
              } />
              {/* <Route path="DashBoard" element={<DashBoard />} /> */}
              <Route path="generalModule" element={<GeneralModuleLayout />} />
          <Route path='*' element={<ErrorModule/>} />
            </Route>
            {/* <Route path='*' element={<ErrorPage/>} /> */}
          </>
      ):(
            <Route path="/" element={<Login />} />
          )}
    </Routes>
  );
};
 
export default Router;
